import * as React from 'react';
import Container from '@mui/material/Container';
import Timeline from '@mui/lab/Timeline';
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';

import ArrivalTimelineItem from './ArrivalTimelineItem.tsx'
import DayTimelineItem from './DayTimelineItem.tsx'
import CeremonyTimelineItem from './CeremonyTimelineItem.tsx'
import DuckBoatTimelineItem from './DuckBoatTimelineItem.tsx'
import MOSTimelineItem from './MOSTimelineItem.tsx'
import WelcomePartyTimelineItem from './WelcomePartyTimelineItem.tsx'
import SleepTimelineItem from './SleepTimelineItem.tsx';
import RunTimelineItem from './RunTimelineItem.tsx';

export default function TimelineAndDetails() {
  return (
    <Container sx={{
      minWidth: "350",
      display: 'flex',
      m: 0,
      p: 0,
    }}>
       <Timeline sx={{
        m:0,
        p:0,
        [`& .${timelineOppositeContentClasses.root}`]: {
          flex: 0.25,
        },
      }}>
        <DayTimelineItem date="5/09" dayOfWeek='Friday' title='May 9th'/>
        {/* <ArrivalTimelineItem />*/}
        <WelcomePartyTimelineItem />
        {/* <SleepTimelineItem /> */}
        
        <DayTimelineItem date="5/10" dayOfWeek='Saturday' title='May 10th'/>
        
        {/* <MOSTimelineItem />
        <DuckBoatTimelineItem />*/}
        <RunTimelineItem />
        <CeremonyTimelineItem />
       
    </Timeline>
    </Container>
  );
}
